import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const AuthGuard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const hash = window.location.hash;

    if (!hash) return;

    let timeoutId;

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (event === 'SIGNED_IN' && session) {
          clearTimeout(timeoutId);
          window.history.replaceState({}, document.title, window.location.pathname);
          if (hash.includes('type=recovery')) {
            navigate('/reset-password', { replace: true });
          } else {
            navigate('/my-profile', { replace: true });
          }
        }

        if (event === 'PASSWORD_RECOVERY') {
          clearTimeout(timeoutId);
          window.history.replaceState({}, document.title, window.location.pathname);
          navigate('/reset-password', { replace: true });
        }
      }
    );

    timeoutId = setTimeout(() => {
      // If nothing happened after 5 seconds, just clear the hash
      if (window.location.hash) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    }, 5000);

    return () => {
      clearTimeout(timeoutId);
      subscription?.unsubscribe();
    };
  }, [navigate, location]);

  return <>{children}</>;
};

export default AuthGuard;
